export enum XanoStorageKeys {
  AuthToken = "AuthToken",
  RealtimeAuthToken = "RealtimeAuthToken",
}
